
import { SuspenseFallback } from '@/components/SuspenseFallback/SuspenseFallback';
import { routePaths } from '@/config';
import { selectOpened } from '@/store/reducers/sidebar/sidebar.selector';
import React, { Suspense, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import Header from '../containers/Header/Header.container';
import './Profile.layout.styles.scss';

type TProps = {};
type PropsFromRedux = ConnectedProps<typeof connector>;

const LProfileFunction: React.FC< TProps & PropsFromRedux> = () => {

  const navigate = useNavigate();

  useEffect(() => {
    navigate(routePaths.profileChildren.homeAbsolute, {replace:true});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="l-profile">
      <div className="l-profile__header-part">
          <Header/>
      </div>
      <div className="l-profile__content-part">
        <Suspense fallback={<SuspenseFallback />}>
          <Outlet />
        </Suspense>
        <div className="footer">
          <span>Copyright &copy; <b>DSTD</b>, tout droit réservé.</span>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  sidebarOpened: selectOpened,
});


const connector = connect(mapStateToProps);
const LProfile = connector(LProfileFunction);

export default LProfile;
